import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import "../../css/companyGlobalStyles.css";

import home from "../../images/home_blanco.png";
import producto from "../../images/producto_blanco.png";
import clientes from "../../images/clientes_blanco.png";
import venta from "../../images/venta_blanco.png";

import { ModalLogin } from "../global/ModalLogin";

import { NavLink } from 'react-router-dom';
import { IconButton } from '@mui/material';

import { useProveedorCompany, UserDropdown, GlobalSearch, short_logo_hosming, returnFullURL, useProovedorData } from "../../components";
import Home_EU from "../empresa/privado/Menu Navbar/Sub Menus/Home_EU";
import { Producto_EU } from "../empresa/privado/Menu Navbar/Sub Menus/Producto_EU";
import { Cliente_EU } from "../empresa/privado/Menu Navbar/Sub Menus/Cliente_EU";
import Reportes_EU from "../empresa/privado/Menu Navbar/Sub Menus/Reportes_EU";

const token = localStorage.getItem("token");

export const NavbarEmpresa = () => {
    const { main_direc } = useParams();

    const { data_user } = useProovedorData() || [];
    const { nit, currentCompany, arrayBranchs, currentBranch, setCurrentBranch } = useProveedorCompany() || {};
    const [stateLogin, setStateLogin] = useState(false);
    const logoEmpresa = returnFullURL(currentCompany?.logo ?? null, "picture");

    const renderContent = () => {
        const selected = main_direc ?? "main";

        if (!currentCompany?.authCode && (arrayBranchs ?? []).length == 0) return;

        switch (selected) {
            case "empresa":
                return (
                    <Home_EU
                        sucursal_selected={currentBranch}
                        obj_sucursal={arrayBranchs}
                        setSelected={setCurrentBranch}
                    />
                );
            case "negocio":
                return (
                    <Producto_EU
                        sucursal_selected={currentBranch?.key_branch}
                        obj_sucursal={arrayBranchs}
                        setSelected={setCurrentBranch}
                    />
                );
            case "cliente":
                return (
                    <Cliente_EU
                        sucursal_selected={currentBranch?.key_branch}
                        obj_sucursal={arrayBranchs}
                        setSelected={setCurrentBranch}
                    />
                );
            case "venta":
                return (
                    <Reportes_EU
                        sucursal_selected={currentBranch?.key_branch}
                        obj_sucursal={arrayBranchs}
                        setSelected={setCurrentBranch}
                    />
                );
            default:
                return <div>Selecciona una opción valida...</div>;
        }
    };


    function handleLogin() {
        if (token) setStateLogin(false);

        setStateLogin((current_val) => !current_val);
    }

    useEffect(() => {
        if (stateLogin == true) setStateLogin(false);
    }, [data_user, currentCompany]);

    return (
        <div id="main-page">
            {/* NAVBAR */}
            <nav className='nav-company' style={{ backgroundColor: 'var(--theme-company)' }}>
                <div className='nav-d1' style={{ backgroundColor: 'var(--theme-main)' }}>
                    <NavLink
                        to={'/'}
                    >
                        <button className="hosming-short">
                            <img src={short_logo_hosming} />
                        </button>
                    </NavLink>

                    <NavLink
                        to={"/company/main?search=" + nit}
                        className='nav-logo'
                    >
                        <img src={logoEmpresa} alt={"logo " + nit} />
                    </NavLink>
                </div>

                <div className='nav-d2'>
                    <ul>
                        <li>
                            <NavLink to={`/administrar/empresa/ventas/${nit}`} className={main_direc == 'empresa' ? 'optionv-active' : ''}>
                                <IconButton>
                                    <img src={home} className='li-icon' />
                                </IconButton>
                            </NavLink>
                        </li>

                        <li>
                            <NavLink to={`/administrar/negocio/productos/${nit}`} className={main_direc == 'negocio' ? 'optionv-active' : ''}>
                                <IconButton>
                                    {/* //FALTA COLORCARLE SU COLOR AQUI */}
                                    <img src={producto} className='li-icon' />
                                </IconButton>
                            </NavLink>
                        </li>

                        <li>
                            <NavLink to={`/administrar/cliente/listar/${nit}`} className={main_direc == 'cliente' ? 'optionv-active' : ''}>
                                <IconButton>
                                    {/* //FALTA COLORCARLE SU COLOR AQUI */}
                                    <img src={clientes} className='li-icon' />
                                </IconButton>
                            </NavLink>
                        </li>

                        <li>
                            <NavLink to={`/administrar/venta/realizar/${nit}`} className={main_direc == 'venta' ? 'optionv-active' : ''}>
                                <IconButton>
                                    {/* //FALTA COLORCARLE SU COLOR AQUI */}
                                    <img src={venta} className='li-icon' />
                                </IconButton>
                            </NavLink>
                        </li>
                    </ul>

                    <GlobalSearch colorIcons={"company"} handleModal={handleLogin} />

                    <UserDropdown handleModal={handleLogin} />
                </div>
            </nav>

            {/* AQUÍ ABAJO RENDERIZAS EL CONTENIDO SEGÚN LA SECCIÓN SELECCIONADA */}
            <div style={{ flex: 1, position: 'relative', overflow: 'hidden', height: 'calc(100vh - var(--height-nav))', maxHeight: 'calc(100vh - var(--height-nav))' }}>
                {renderContent()}
            </div>

            <ModalLogin stateModal={!token && stateLogin ? true : false} handleModal={handleLogin} />
        </div>
    );
};
